import api from "./api";

export type Industry = { key: string; name: string };
export type Brand = { industry: string; slug: string; name: string };
export type Model = { brand: string; name: string };

export const listIndustries = async (): Promise<Industry[]> => {
  const res = await api.get("/catalog/industries");
  return res.data || [];
};

export const getIndustrySummary = async (industryKey: string, token: string) => {
  const res = await api.get(`/catalog/${industryKey}/summary`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data as { industry: Industry; jobTypes: string[]; deviceTypes: string[]; menus?: string[]; ticketFields?: Array<{ id: string; label: string; type: 'text' | 'number' | 'boolean' }> };
};

export const getBrands = async (industryKey: string, token: string): Promise<Brand[]> => {
  const res = await api.get(`/catalog/${industryKey}/brands`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data || [];
};

export const getModels = async (brandSlug: string, token: string): Promise<Model[]> => {
  const res = await api.get(`/catalog/brands/${brandSlug}/models`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data || [];
};
